import { format } from "date-fns";
import FilterRegister from "../../../../components/filter/register-basic";
import reqConta from "../../../../services/reqMultiTenant/reqConta";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";

const MainRegisterBank = () => {
	const options = {
		id: "id_conta", //usado para saber qual field usar para atualizar
		ident: "bankRegister", //usado para definir os event listners
		identFilter: "filterBank", //usado para definir os event listners
		title: "Banco",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "banco", label: "Banco", align: "left" },
			{ key: "saldo", label: "Saldo", align: "left", format: "currency" },
			{ key: "empty1", label: "", align: "left" },
			{ key: "empty2", label: "", align: "left" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Banco", value: "banco" }],
	};

	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

		const response = await reqConta.listPaginate(param, paramValue, active, newPage);

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqConta.listID(currentId);

		return response;
	};

	const insert = async (data) => {
		const response = await reqConta.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterBank;
